import {Component} from '@angular/core';
import {DashboardSearchBaseComponent} from '@common/dashboard/dashboard-search.component.base';

@Component({
    selector: 'sm-dashboard-search',
    templateUrl: './dashboard-search.component.html',
    styleUrls: ['./dashboard-search.component.scss'],
    standalone: false
})
export class DashboardSearchComponent extends DashboardSearchBaseComponent {

}
